import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Ga4Service } from './services/ga4.service';
import { ConsentService, isAuthenticatedPath } from './services/consent.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'rapalmanac-angular';
  constructor(
    private ga4: Ga4Service,
    private consent: ConsentService,
    private router: Router,
  ) {
    // Page titles are functional — always on, no cookies, no tracking.
    this.ga4.startTitleTracking();

    // Anonymous visitors: analytics loads only if they Accept the cookie banner.
    this.consent.status$.subscribe((status) => {
      if (status === 'accepted') {
        this.ga4.init();
      }
    });

    // Subscribers: the authenticated app is AuthGuard-protected, so a navigation
    // that lands inside it is a signed-in subscriber who agreed to the policies
    // at checkout — the consent basis for in-app analytics. Enable GA there.
    // Route-based only: reads the URL the guard already approved, no auth calls.
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (isAuthenticatedPath(event.urlAfterRedirects)) {
          this.ga4.init();
        }
      });
  }
}
